module.exports = __webpack_public_path__ + "img/smallTruck-red.fd067090.svg";